import { Kind, } from "graphql";
export function isOperationDefinitionNode(node) {
    return node.kind === Kind.OPERATION_DEFINITION;
}
export function isFragmentDefinitionNode(node) {
    return node.kind === Kind.FRAGMENT_DEFINITION;
}
export function isFieldNode(node) {
    return node.kind === Kind.FIELD;
}
export function isFragmentSpreadNode(node) {
    return node.kind === Kind.FRAGMENT_SPREAD;
}
export function isInlineFragmentNode(node) {
    return node.kind === Kind.INLINE_FRAGMENT;
}
export function isNamedTypeNode(node) {
    return node.kind === Kind.NAMED_TYPE;
}
export function isListTypeNode(node) {
    return node.kind === Kind.LIST_TYPE;
}
export function isNonNullTypeNode(node) {
    return node.kind === Kind.NON_NULL_TYPE;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9kZS10eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvbm9kZS10eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBTUwsSUFBSSxHQVFMLE1BQU0sU0FBUyxDQUFDO0FBZWpCLE1BQU0sVUFBVSx5QkFBeUIsQ0FBQyxJQUFvQjtJQUM1RCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLG9CQUFvQixDQUFDO0FBQ2pELENBQUM7QUFFRCxNQUFNLFVBQVUsd0JBQXdCLENBQUMsSUFBb0I7SUFDM0QsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxtQkFBbUIsQ0FBQztBQUNoRCxDQUFDO0FBRUQsTUFBTSxVQUFVLFdBQVcsQ0FBQyxJQUFtQjtJQUM3QyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLEtBQUssQ0FBQztBQUNsQyxDQUFDO0FBRUQsTUFBTSxVQUFVLG9CQUFvQixDQUFDLElBQW1CO0lBQ3RELE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsZUFBZSxDQUFDO0FBQzVDLENBQUM7QUFFRCxNQUFNLFVBQVUsb0JBQW9CLENBQUMsSUFBbUI7SUFDdEQsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxlQUFlLENBQUM7QUFDNUMsQ0FBQztBQUNELE1BQU0sVUFBVSxlQUFlLENBQUMsSUFBYztJQUM1QyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLFVBQVUsQ0FBQztBQUN2QyxDQUFDO0FBRUQsTUFBTSxVQUFVLGNBQWMsQ0FBQyxJQUFjO0lBQzNDLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsU0FBUyxDQUFDO0FBQ3RDLENBQUM7QUFFRCxNQUFNLFVBQVUsaUJBQWlCLENBQUMsSUFBYztJQUM5QyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLGFBQWEsQ0FBQztBQUMxQyxDQUFDIn0=